@let currentLanguage = this.currentLanguage();
@let isFrench = currentLanguage === 'fr-CA';

<div class="content">
  @if (isFrench) {
    <img
      src="/images/service-center-sections/more-work-content-fr.svg"
      width="670"
      height="418"
      alt="Work Content"
    />
  } @else {
    <img
      src="/images/service-center-sections/more-work-content-en.svg"
      width="646"
      height="480"
      alt="Work Content"
    />
  }
</div>

<div class="link">
  @let qrCodeLinkEn = 'https://oon.gl/R2w5H4';
  @let qrCodeLinkFr = 'https://oon.gl/h472rf';

  <app-qrcode
    class="qr-code"
    variant="blue"
    [content]="isFrench ? qrCodeLinkFr : qrCodeLinkEn"
    [size]="400"
  />
</div>

<img
  class="hand"
  src="/images/service-center-sections/more-work-hand.svg"
  width="312"
  height="312"
  alt="Hand"
/>
